var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00053 7.80028C6.76165 7.80028 6.52272 7.70907 6.34054 7.52706L0.607506 1.79388C0.24281 1.42918 0.24281 0.837892 0.607506 0.473343C0.972054 0.108795 1.56323 0.108795 1.92795 0.473343L7.00053 5.5463L12.0733 0.473697C12.4379 0.109148 13.0291 0.109148 13.3936 0.473697C13.7585 0.838245 13.7585 1.42936 13.3936 1.79405L7.66069 7.52726C7.47842 7.70924 7.23949 7.80028 7.00053 7.80028Z",
    fill: "#151B26"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default ForwardRef;